export const namespaced = true;

export const state = {
    supplierStatusValue: 'USER_ACCOUNT_CREATED',
};

export const getters = {
    supplierStatusValue: state => state.supplierStatusValue,
    daysToExpiryValue: state => state.daysToExpiryValue,
    userSelectedRenewalActionValue: state => state.userSelectedRenewalActionValue,
};

export const mutations = {
    setSupplierStatusValue(state, newStatus) {
        state.supplierStatusValue = newStatus
    },
    setDaysToExpiryValue(state, newDaysToExpiry) {
        state.daysToExpiryValue = newDaysToExpiry
    },
    setUserSelectedRenewalAction(state, newAction) {
        state.userSelectedRenewalActionValue = newAction
    },
};

export const actions = {
    fetchTodos({ commit }) {
        commit('setSupplierStatusValue', '')
        commit('setDaysToExpiryValue', 0)
        commit('userSelectedRenewalActionValue', 'NO_ACTION')
    },
};
